// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form } from 'semantic-ui-react';
import _ from 'lodash';
// local
// views
import DropdownClient from 'app/ui/commons/DropdownClient';
import SaveUpdateModal from './SaveUpdateModal';
import PasswordLabel from 'app/ui/commons/PasswordLabel';
import CustomDropdown from 'app/ui/commons/CustomDropdown';
import ErrorLabel from 'app/ui/commons/ErrorLabel';
// libs
import { isValidEmail, isValidPassowrd, isFormValid, removeReadOnly } from 'app/lib/formHelper';
import { _val, sortString } from 'app/lib/helper';
import t from 'app/lib/i18n';
// actions
import { ACTION } from 'app/redux/actions/modal';
import { create, update } from 'app/redux/actions/account';
// consts
import { TYPE as CLIENT_TYPE, STATUS as CLIENT_STATUS } from 'salvus-shared/consts/client';
import { PROFILE as ACCOUNT_PROFILE } from 'salvus-shared/consts/account';

class AccountModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            accountProfiles: this.initAccountProfiles(),
            form: this.initForm(),
            errors: {},
        };
    }

    componentWillReceiveProps(nextProps) {
        const { isOpened: isOpenedP } = this.props.modalSaveUpdate;
        const { isOpened: isOpenedN, action: actionN, data: dataN } = nextProps.modalSaveUpdate;

        if (!isOpenedP && isOpenedN) {
            const { client, profile } = nextProps.auth.account;
            const values = actionN === ACTION.UPDATE ? dataN : {};
            if (!(client.type === CLIENT_TYPE.SALVUS && profile === ACCOUNT_PROFILE.ADMIN)) {
                values.clientId = client.id;
            }
            this.setState({ form: this.initForm(values), errors: {} });
        }
    }

    initForm(values = {}) {
        return {
            id: _val(values.id, null),
            name: _val(values.name, ''),
            email: _val(values.email, ''),
            password: '',
            profile: _val(values.profile, -1),
            clientId: _val(values.clientId, null),
        };
    }

    initAccountProfiles() {
        const profiles = Object.keys(ACCOUNT_PROFILE).map(key => {
            const value = ACCOUNT_PROFILE[key];
            return {
                text: t(`account_profile_${value}`),
                value,
            };
        });
        profiles.sort((a, b) => sortString(a.text, b.text));
        return profiles;
    }

    validateForm(form, field) {
        const errors = {};

        const name = form.name;
        if (!field || field === 'name') {
            if (_.isEmpty(name)) {
                errors['name'] = 'O campo nome é obrigatório.';
            } else {
                errors['name'] = undefined;
            }
        }

        const email = form.email;
        if (!field || field === 'email') {
            if (_.isEmpty(email)) {
                errors['email'] = 'O campo e-mail é obrigatório.';
            } else if (!isValidEmail(email)) {
                errors['email'] = 'O campo e-mail não é válido.';
            } else {
                errors['email'] = undefined;
            }
        }

        const { action } = this.props.modalSaveUpdate;
        const password = form.password;
        const length = password.length;
        if (!(action === ACTION.UPDATE && length === 0)) {
            if (!field || field === 'password') {
                if (length === 0 || length < 8 || length > 20) {
                    errors['password'] = 'O campo senha não possui um tamanho adequado.';
                } else if (!isValidPassowrd(password)) {
                    errors['password'] = 'O campo senha não é válido.';
                } else {
                    errors['password'] = undefined;
                }
            }
        }

        const profile = form.profile;
        if (!field || field === 'profile') {
            if (profile <= -1) {
                errors['profile'] = 'É obrigatório selecionar o perfil do usuário.';
            } else {
                errors['profile'] = undefined;
            }
        }

        const clientId = form.clientId;
        if (!field || field === 'clientId') {
            if (clientId === null) {
                errors['clientId'] = 'É obrigatório selecionar o cliente.';
            } else {
                errors['clientId'] = undefined;
            }
        }

        return errors;
    }

    onChange = field => (e, target) => {
        const { value } = target || e.target;
        let { form, errors } = this.state;
        _.set(form, field, value);
        const validation = this.validateForm(form, field);
        _.forIn(validation, function(value, key) {
            errors[key] = value;
        });
        this.setState({ form, errors });
    };

    hasError = field => !_.isEmpty(this.state.errors[field]);

    onConfirmModal = () => {
        // check if there is any error in the form
        const errors = this.validateForm(this.state.form);
        if (!isFormValid(errors)) {
            this.setState({ errors });
            // return false to not close the popup
            return false;
        }
        // if there are not errors, submit to the backend
        const { form } = this.state;
        const { action } = this.props.modalSaveUpdate;
        if (action === ACTION.ADD) {
            this.props.dispatch(create(form));
        } else if (action === ACTION.UPDATE) {
            this.props.dispatch(update(form.id, form));
        }
        // return false to not close the popup
        return false;
    };

    render() {
        // props
        const { dispatch, modalSaveUpdate, auth } = this.props;
        const options = {
            dispatch,
            title: 'Usuário',
            onConfirmModal: this.onConfirmModal,
            action: modalSaveUpdate.action,
            isOpened: modalSaveUpdate.isOpened,
            loading: modalSaveUpdate.loading,
            error: modalSaveUpdate.error,
        };
        // state
        const { accountProfiles, form, errors } = this.state;
        return (
            <SaveUpdateModal id="accountModal" options={options}>
                <Form>
                    <Form.Group>
                        <Form.Input
                            label={<ErrorLabel label="Nome" error={errors['name']} />}
                            placeholder="Nome"
                            width={16}
                            value={form.name}
                            onChange={this.onChange('name')}
                            error={this.hasError('name')}
                            maxLength="80"
                            readOnly
                            onFocus={removeReadOnly}
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Input
                            label={<ErrorLabel label="E-mail" error={errors['email']} />}
                            placeholder="E-mail"
                            type="email"
                            width={8}
                            value={form.email}
                            onChange={this.onChange('email')}
                            error={this.hasError('email')}
                            maxLength="255"
                            readOnly
                            onFocus={removeReadOnly}
                        />
                        <Form.Input
                            label={<ErrorLabel label={<PasswordLabel />} error={errors['password']} />}
                            type="password"
                            width={8}
                            value={form.password}
                            onChange={this.onChange('password')}
                            error={this.hasError('password')}
                            maxLength="20"
                            readOnly
                            onFocus={removeReadOnly}
                        />
                    </Form.Group>
                    <Form.Group>
                        {auth.account.client.type === CLIENT_TYPE.SALVUS && (
                            <DropdownClient
                                width={8}
                                value={form.clientId}
                                onChange={this.onChange('clientId')}
                                filter={[CLIENT_STATUS.NEW, CLIENT_STATUS.ENABLED]}
                                error={errors['clientId']}
                                showSalvus
                            />
                        )}
                        <CustomDropdown
                            label={<ErrorLabel label="Perfil" error={errors['profile']} />}
                            placeholder="Perfil"
                            width={auth.account.client.type === CLIENT_TYPE.SALVUS ? 8 : 16}
                            options={accountProfiles}
                            value={form.profile}
                            onChange={this.onChange('profile')}
                            error={this.hasError('profile')}
                            selection
                        />
                    </Form.Group>
                </Form>
            </SaveUpdateModal>
        );
    }
}

AccountModal.propTypes = {
    modalSaveUpdate: PropTypes.object,
    auth: PropTypes.object,
    dispatch: PropTypes.func,
};

const mapStateToProps = state => ({
    auth: state.auth,
    modalSaveUpdate: state.modalSaveUpdate,
});
export default connect(mapStateToProps)(AccountModal);
